import React from "react";
import { FaGithub } from "react-icons/fa";
require("./../../assets/stylesheets/OAuth/OAuth.css");

const SignInGitHubButton = () => {
  const gitHubSignIn = () => {
    window.open("https://ferias-ingenio-backend.vercel.app/api/auth/github", "_self");
    // window.open("http://localhost:5000/api/auth/github", "_self");
  };

  return (
    <div className="github-signin-button" onClick={gitHubSignIn}>
      <div className="icon-button">
        <FaGithub />
      </div>
      Iniciar Sesión GitHub
    </div>
  );
};

export default SignInGitHubButton;
